var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.data.status == "success" ||
    _vm.data.status == "pending" ||
    _vm.data.status == "scheduled" ||
    _vm.data.type == "scheduled"
    ? _c(
        "b-colxx",
        { staticClass: "mb-3", attrs: { xxs: "12" } },
        [
          _c(
            "b-card",
            {
              class: {
                "d-flex flex-row": true,
                "highlight-latest": _vm.highlight,
              },
              attrs: { "data-cy": `${_vm.cyPrefix}`, "no-body": "" },
              on: {
                click: function ($event) {
                  return _vm.onClickEvent($event, _vm.data.id)
                },
              },
            },
            [
              _c("dialog-date-time", {
                attrs: {
                  disabled: _vm.data.showOnly,
                  data: _vm.data,
                  dialog: _vm.dialogs.schedule,
                },
                on: {
                  "dialog-close": _vm.closeDialogSchedule,
                  "dialog-submit": _vm.onSubmitDialogSchedule,
                },
              }),
              _vm._v(" "),
              _c("dialog-alert", {
                attrs: {
                  dialog: _vm.dialogs.alert,
                  description: _vm.$t("alert.delete"),
                  actionType: _vm.$t("buttons.delete"),
                  buttonSubmitText: _vm.$t("buttons.delete"),
                },
                on: {
                  "dialog-close": _vm.closeDialogAlert,
                  "dialog-submit": _vm.onSubmitDialogAlert,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "pl-2 d-flex flex-grow-1 min-width-zero" },
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "card-body align-self-center flex-lg-row justify-content-between min-width-zero align-items-lg-center w-60",
                    },
                    [
                      _c(
                        "b-row",
                        [
                          _vm.platformBadges.length > 0
                            ? _c("BadgeListPlatform", {
                                attrs: {
                                  cyPrefix: `${_vm.cyPrefix}`,
                                  data: _vm.platformBadges,
                                },
                              })
                            : _vm._e(),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("b-row", [
                        _c(
                          "p",
                          {
                            staticClass: "mb-1 text-muted",
                            attrs: { "data-cy": `${_vm.cyPrefix}-description` },
                          },
                          [_vm._v(_vm._s(_vm.data.post))]
                        ),
                      ]),
                      _vm._v(" "),
                      _vm.data.scheduleDate || _vm.data.status
                        ? _c("b-row", [
                            _c(
                              "div",
                              {
                                staticClass:
                                  "d-flex align-items-center mb-1 text-small",
                              },
                              [
                                _vm.data.scheduleDate
                                  ? _c(
                                      "small",
                                      { staticClass: "text-muted mr-2" },
                                      [
                                        _c("i", {
                                          staticClass: "simple-icon-calendar",
                                        }),
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.formatDate(
                                                _vm.data.scheduleDate
                                              )
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.data.status
                                  ? _c(
                                      "span",
                                      {
                                        staticClass: "status-badge ml-2",
                                        class: _vm.data.status.toLowerCase(),
                                      },
                                      [
                                        _vm._v(
                                          "\n              " +
                                            _vm._s(
                                              _vm.formatStatus(_vm.data.status)
                                            ) +
                                            "\n            "
                                        ),
                                      ]
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.data.analytics &&
                      (_vm.data.analytics.totalLikes > 0 ||
                        _vm.data.analytics.totalComments > 0 ||
                        _vm.data.analytics.totalShares > 0 ||
                        _vm.data.analytics.totalViews > 0 ||
                        _vm.data.analytics.totalReach > 0)
                        ? _c("b-row", [
                            _c(
                              "div",
                              { staticClass: "engagement-metrics mt-2" },
                              [
                                _c(
                                  "div",
                                  { staticClass: "d-flex flex-wrap gap-2" },
                                  [
                                    _vm.data.analytics.totalLikes > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "engagement-badge likes",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "simple-icon-heart",
                                            }),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    _vm.data.analytics
                                                      .totalLikes
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.data.analytics.totalComments > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "engagement-badge comments",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "simple-icon-bubble",
                                            }),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    _vm.data.analytics
                                                      .totalComments
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.data.analytics.totalShares > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "engagement-badge shares",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "simple-icon-share",
                                            }),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    _vm.data.analytics
                                                      .totalShares
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.data.analytics.totalViews > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "engagement-badge views",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "simple-icon-eye",
                                            }),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    _vm.data.analytics
                                                      .totalViews
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.data.analytics.totalReach > 0
                                      ? _c(
                                          "span",
                                          {
                                            staticClass:
                                              "engagement-badge reach",
                                          },
                                          [
                                            _c("i", {
                                              staticClass: "simple-icon-people",
                                            }),
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(
                                                  _vm.formatNumber(
                                                    _vm.data.analytics
                                                      .totalReach
                                                  )
                                                ) +
                                                "\n            "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ]
                                ),
                                _vm._v(" "),
                                _vm.data.analytics.platformBreakdown &&
                                Object.keys(
                                  _vm.data.analytics.platformBreakdown
                                ).length > 0
                                  ? _c(
                                      "div",
                                      { staticClass: "mt-2" },
                                      [
                                        _c(
                                          "b-button",
                                          {
                                            staticClass: "p-0 text-muted",
                                            attrs: {
                                              variant: "link",
                                              size: "sm",
                                            },
                                            on: {
                                              click:
                                                _vm.togglePlatformBreakdown,
                                            },
                                          },
                                          [
                                            _c("i", {
                                              class: _vm.showPlatformBreakdown
                                                ? "simple-icon-arrow-up"
                                                : "simple-icon-arrow-down",
                                            }),
                                            _vm._v(
                                              "\n              Platform Details\n            "
                                            ),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.showPlatformBreakdown
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "platform-breakdown mt-2",
                                              },
                                              _vm._l(
                                                _vm.data.analytics
                                                  .platformBreakdown,
                                                function (metrics, platform) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: platform,
                                                      staticClass:
                                                        "platform-metrics mb-2",
                                                    },
                                                    [
                                                      _c(
                                                        "small",
                                                        {
                                                          staticClass:
                                                            "text-muted font-weight-bold",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              platform.toUpperCase()
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "d-flex flex-wrap gap-1 mt-1",
                                                        },
                                                        [
                                                          metrics.likes > 0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "small-badge likes",
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "simple-icon-heart",
                                                                  }),
                                                                  _vm._v(
                                                                    "\n                    " +
                                                                      _vm._s(
                                                                        _vm.formatNumber(
                                                                          metrics.likes
                                                                        )
                                                                      ) +
                                                                      "\n                  "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          metrics.comments > 0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "small-badge comments",
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "simple-icon-bubble",
                                                                  }),
                                                                  _vm._v(
                                                                    "\n                    " +
                                                                      _vm._s(
                                                                        _vm.formatNumber(
                                                                          metrics.comments
                                                                        )
                                                                      ) +
                                                                      "\n                  "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          metrics.shares > 0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "small-badge shares",
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "simple-icon-share",
                                                                  }),
                                                                  _vm._v(
                                                                    "\n                    " +
                                                                      _vm._s(
                                                                        _vm.formatNumber(
                                                                          metrics.shares
                                                                        )
                                                                      ) +
                                                                      "\n                  "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          metrics.views > 0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "small-badge views",
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "simple-icon-eye",
                                                                  }),
                                                                  _vm._v(
                                                                    "\n                    " +
                                                                      _vm._s(
                                                                        _vm.formatNumber(
                                                                          metrics.views
                                                                        )
                                                                      ) +
                                                                      "\n                  "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                          _vm._v(" "),
                                                          metrics.reach > 0
                                                            ? _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "small-badge reach",
                                                                },
                                                                [
                                                                  _c("i", {
                                                                    staticClass:
                                                                      "simple-icon-people",
                                                                  }),
                                                                  _vm._v(
                                                                    "\n                    " +
                                                                      _vm._s(
                                                                        _vm.formatNumber(
                                                                          metrics.reach
                                                                        )
                                                                      ) +
                                                                      "\n                  "
                                                                  ),
                                                                ]
                                                              )
                                                            : _vm._e(),
                                                        ]
                                                      ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _vm._e(),
                                      ],
                                      1
                                    )
                                  : _vm._e(),
                              ]
                            ),
                          ])
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isRewardItem
                    ? _c("ButtonBlockInListReward", {
                        attrs: {
                          config: {
                            id: _vm.data.id,
                            name: `${_vm.cyPrefix}`,
                            points: {
                              requiredPoints: _vm.data.requiredPoints,
                            },
                            toggleBtn: {
                              status: _vm.data.status,
                              disabled: !_vm.data.isValid,
                              change: function (payload) {
                                _vm.updateStatus(payload)
                              },
                            },
                            imgBtnDuplicate: {
                              click: function () {
                                _vm.onDuplicateItem()
                              },
                            },
                            imgBtnEdit: {
                              click: function () {
                                _vm.onEditItem()
                              },
                            },
                            imgBtnDelete: {
                              click: function () {
                                _vm.openDialogAlert()
                              },
                            },
                            expireDate: _vm.data.availableTo,
                          },
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }